import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { closeRecommendationsModal } from '../../actions/recommendations-modal';
import {
    RecommendationsModal,
    RecommendationsModalProps
} from '../../components/RecommendationsModal/RecommendationsModal';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<RecommendationsModalProps>;

type DispatchProps = TDispatchProps<RecommendationsModalProps>;

const mapStateToProps = (state: State): StateProps => {
    const { isVisible, data, headerHint } = state.recommendationsModal;

    return {
        isVisible,
        data,
        headerHint
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onClose: () => dispatch(closeRecommendationsModal())
    };
};

export const RecommendationsModalContainer = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(RecommendationsModal);
